import {
  ActionOverRecordTypes,
  createFormModalConfig,
  createLocalizationKey,
  FieldBuilder,
  FieldDefinition,
  IActionsSchema,
  modalAction,
  ZendraLocalizationServices,
} from '@zendra/shared';
import type { GridOption } from 'angular-slickgrid';
import {
  GISSTANDINCONSISTENCY_MENU_CATEGORY,
  GISSTANDINCONSISTENCY_MENU_SUBCATEGORY,
  GISSTANDINCONSISTENCY_PERMISSION,
} from '../gis-stand-inconsistency/gis-stand-inconsistency.config';
import { ActionCreateStandAreaMaintenance } from '../stand-area-maintenance/action-create-stand-area-maintenance/action-create-stand-area-maintenance';

FieldBuilder.setNamespace('Geographic');

export const STAND_AREA_DIFFERENCE_THRESHOLD = 0.1;

export const GISSTANDAREADIFFERENCE_FIELDS: FieldDefinition[] = [
  FieldBuilder.number('regionId', 'Entity.GisStandInconsistency.RegionId')
    .hideByDefault()
    .gridColumnMinWidth(110)
    .build(),
  FieldBuilder.text('regionCode', 'Entity.GisStandInconsistency.RegionCode')
    .readOnly()
    .gridColumnMinWidth(130)
    .build(),
  FieldBuilder.text('regionName', 'Entity.GisStandInconsistency.RegionName')
    .readOnly()
    .gridColumnMinWidth(140)
    .build(),
  FieldBuilder.number('propertyId', 'Entity.GisStandInconsistency.PropertyId')
    .hideByDefault()
    .gridColumnMinWidth(110)
    .build(),
  FieldBuilder.text('propertyName', 'Entity.GisStandInconsistency.Property')
    .readOnly()
    .gridColumnMinWidth(180)
    .build(),
  FieldBuilder.number('standId', 'Entity.GisStandInconsistency.StandId')
    .hideByDefault()
    .gridColumnMinWidth(100)
    .build(),
  FieldBuilder.text('standName', 'Entity.GisStandInconsistency.Name')
    .readOnly()
    .gridColumnMinWidth(140)
    .build(),
  FieldBuilder.number('speciesId', 'Entity.GisStandInconsistency.SpeciesId')
    .hideByDefault()
    .gridColumnMinWidth(110)
    .build(),
  FieldBuilder.text('speciesName', 'Entity.GisStandInconsistency.Species')
    .readOnly()
    .gridColumnMinWidth(150)
    .build(),
  FieldBuilder.date('plantationDate', 'Entity.GisStandInconsistency.PlantationDate')
    .readOnly()
    .gridColumnMinWidth(150)
    .build(),
  FieldBuilder.number('standArea', 'Entity.GisStandInconsistency.StandArea')
    .decimal()
    .readOnly()
    .gridColumnMinWidth(130)
    .build(),
  FieldBuilder.number('gisArea', 'Entity.GisStandInconsistency.GisArea')
    .decimal()
    .readOnly()
    .gridColumnMinWidth(130)
    .build(),
  FieldBuilder.text('forestrySituationName', 'Entity.GisStandInconsistency.ForestrySituation')
    .readOnly()
    .gridColumnMinWidth(170)
    .build(),
  FieldBuilder.number('areaDifference', 'Entity.GisStandInconsistency.AreaDifference')
    .decimal()
    .readOnly()
    .hideByDefault()
    .gridColumnMinWidth(150)
    .build(),
];

export const GISSTANDAREADIFFERENCE_TABLE_OPTIONS: GridOption = {
  enableFiltering: true,
  enableSorting: true,
};

export const GISSTANDAREADIFFERENCE_ACTION_IDS = {
  createStandAreaMaintenance: 0,
};

export const GISSTANDAREADIFFERENCE_ACTIONS_CONFIG: IActionsSchema = {
  overTable: [],
  multipleRecord: [
    modalAction(
      GISSTANDAREADIFFERENCE_ACTION_IDS.createStandAreaMaintenance,
      'Action.Modal.createStandAreaMaintenance',
      ActionOverRecordTypes.MultipleRecord,
      createFormModalConfig({
        component: ActionCreateStandAreaMaintenance,
        title: createLocalizationKey(
          'Action.Modal.createStandAreaMaintenance',
          ZendraLocalizationServices.Geographic,
        ),
        subTitle: createLocalizationKey(
          'Entity.StandAreaMaintenance',
          ZendraLocalizationServices.Geographic,
        ),
        size: 'xl',
        inputs: {
          mode: 'bulkFromSelection',
          hideStandField: true,
          hideAreaToBeAdjustedField: true,
          hideIsAreaUpdatedField: true,
        },
      }),
      ZendraLocalizationServices.Geographic,
    ),
  ],
  singleRecord: [],
};

export const GISSTANDAREADIFFERENCE_CONFIG = {
  entityName: 'GisStandAreaDifference',
  localizationKey: 'Geographic::Entity.GisStandInconsistency.AreaDifference',
  fields: GISSTANDAREADIFFERENCE_FIELDS,
  permission: GISSTANDINCONSISTENCY_PERMISSION,
  actions: GISSTANDAREADIFFERENCE_ACTIONS_CONFIG,
  actionIds: GISSTANDAREADIFFERENCE_ACTION_IDS,
  showInMenu: false,
  menuCategory: GISSTANDINCONSISTENCY_MENU_CATEGORY,
  menuSubcategory: GISSTANDINCONSISTENCY_MENU_SUBCATEGORY,
};
